module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-color"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "error-content"
  }, [_c('h2', [_vm._v("Page Not Found")]), _vm._v(" "), _c('p', [_vm._v("The page you are looking for has been moved or no longer exists.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("Return Home")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cf0d680"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = 308
// module chunks = 1